const LANGUAGES = {
  vcl: "VCL",
  rust: "Rust",
  javascript: "JavaScript",
  assemblyscript: "AssemblyScript",
  go: "Go",
}

export default LANGUAGES
